/**
 * This file is used to store a central socket connection that can be used throughout the application.
 */
import io from 'socket.io-client';

// Use the same URL as the server
const socket = io({ autoConnect: false });

export const connectSocket = () => {
    if (!socket.connected) socket.connect();
};

export const disconnectSocket = () => {
    if (socket.connected) socket.disconnect();
};

export default socket;
